import APIClient from '@/shared/http/clients/api'

const resourceName = 'obramembro'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAllFunctions = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/funcoesObra`, data, config)
const PrintTeam = (obraMembroID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/relatorio/${obraMembroID}`, data, config)
const GetFunctionByCode = (codigo, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/funcoesObra/codigo/${codigo}`, data, config)
const Get = (obraMembroID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${obraMembroID}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Delete = (obraMembroID, data = {}, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${obraMembroID}`, data, config)
const GetLogs = (obraID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/log/${obraID}`, data, config)

const ConstructionMemberRepository = {
  Get,
  Update,
  Delete,
  Create,
  GetAllFunctions,
  GetFunctionByCode,
  PrintTeam,
  GetLogs
}

export default ConstructionMemberRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/constructionmember.js